import MetaObject from "../../../../src/mdx/api/schema/meta-object.mdx";
import * as React from 'react';
export default {
  MetaObject,
  React
};